export function getDiscordIconUrl(
  guildId: string,
  icon: string | null
): string | undefined {
  if (!icon) return undefined;
  const ext = icon.startsWith("a_") ? "gif" : "png";
  return `https://cdn.discordapp.com/icons/${guildId}/${icon}.${ext}`;
}

export function getDefaultAvatarUrl(userId: string): string {
  const index = /^\d+$/.test(userId)
    ? Number(BigInt(userId) >> BigInt(22)) % 6
    : 0;
  return `https://cdn.discordapp.com/embed/avatars/${index}.png`;
}

export function getDiscordAvatarUrl(
  userId: string,
  avatar: string | null
): string {
  if (!avatar) return getDefaultAvatarUrl(userId);
  if (avatar.startsWith("http")) return avatar;
  const ext = avatar.startsWith("a_") ? "gif" : "png";
  return `https://cdn.discordapp.com/avatars/${userId}/${avatar}.${ext}`;
}

export function getDiscordAppIconUrl(
  appId: string,
  icon: string | null
): string | undefined {
  if (!icon) return undefined;
  return `https://cdn.discordapp.com/app-icons/${appId}/${icon}.png`;
}

export function buildBotInviteUrl(clientId: string, guildId: string): string {
  return `https://discord.com/oauth2/authorize?client_id=${clientId}&permissions=8&integration_type=0&scope=bot+applications.commands&guild_id=${guildId}`;
}
